import { t } from "i18next";

import { Box, Button, Typography } from "@mui/material";

import { theme } from "@/src/theme/theme";

interface MicrosoftLoginButtonProps {
  click: () => void;
  text: string;
}

const MicrosoftLoginButton = (props: MicrosoftLoginButtonProps) => {
  const { click, text } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        mt: 3,
        mb: 3
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: theme.palette.semantic.secondary.main,
          mb: 2,
          textAlign: "center"
        }}
      >
        {t("general.loginWithMicrosoft")}
      </Typography>
      <Button
        variant="contained"
        fullWidth
        sx={(theme) => ({
          backgroundColor: theme.palette.semantic.primary.main,
          color: theme.palette.semantic.primary.contrastText,
          textTransform: "none",
          fontWeight: theme.typography.fontWeightSemibold,
          fontSize: theme.typography.h4.fontSize,
          borderRadius: "0",
          height: "50px",
          maxWidth: "320px",
          boxShadow: `0 2px 4px ${theme.palette.misc.outlineBorder}`,
          "&:hover": {
            backgroundColor: theme.palette.semantic.primary.dark
          }
        })}
        onClick={click}
      >
        {text}
      </Button>
    </Box>
  );
};

export default MicrosoftLoginButton;
